
















































































import Vue, { PropType } from 'vue'
import {
  faChevronLeft,
  faChevronRight,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import CSwipeMixin from '~/components/shared/configurable/mixin/CSwipeMixin.vue'
import { ZoomerFile } from './types'
import CDragScroll from '~/components/shared/configurable/CDragScroll.vue'
import CCarouselThumb from '~/components/shared/configurable/image/carousel/CCarouselThumb.vue'
import { useModalToggle } from '~/compositions/modal-toggle.ts'

interface Data {
  activeIndex: number
  showNavsMobile: boolean
  icons: object
}

export default Vue.extend({
  components: { CCarouselThumb, CDragScroll },
  mixins: [CSwipeMixin],
  setup() {
    const modalToggleFunc = useModalToggle()
    return { modalToggleFunc }
  },
  props: {
    // supported files: images and pdfs
    filesToShow: {
      type: Array as PropType<ZoomerFile[]>,
      required: true
    },
    startIndex: {
      type: Number,
      required: false,
      default: 0
    },
    usePortal: {
      type: Boolean,
      required: false,
      default: false
    },
    modalInSearch: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data(): Data {
    return {
      activeIndex: 0,
      showNavsMobile: true,
      thumbsLoaded: 0,
      canClickThumbs: true
    }
  },
  computed: {
    icons() {
      return {
        close: faTimes,
        chevronLeft: faChevronLeft,
        chevronRight: faChevronRight
      }
    },
    activeFile() {
      return this.filesToShow[this.activeIndex]
    },
    isSwipable() {
      return this.filesToShow.length > 1
    },
    hasImages() {
      return this.filesToShow.some(f => f.type === 'image' || f.type === 'img')
    },
    hasPdfs() {
      return this.filesToShow.some(f => f.type === 'pdf')
    }
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.navigate)
  },
  mounted() {
    this.modalToggleFunc.setModalInSearch(this.modalInSearch)
    this.modalToggleFunc.setOnModalCloseCallback(this.onModalClose)
    this.show(this.startIndex)
  },
  methods: {
    show(index) {
      // this.activeIndex = index
      document.addEventListener('keyup', this.navigate)
      this.modalToggleFunc.modalOpen()
      this.$nextTick(() => {
        if (this.isSwipable) {
          if (this.$refs.scroller) {
            this.$refs.scroller.calcDsWidth()
          }
          this.activateThumb(index)
        }
      })
    },
    onModalClose() {
      document.removeEventListener('keyup', this.navigate)
      this.$emit('zoomer-closed')
    },
    imgLoad(index) {
      if (this.$refs.scroller) {
        this.$refs.scroller.calcDsWidth()
      }
      this.$nextTick(() => {
        if (this.activeIndex === index) {
          this.activateThumb(index)
        }
      })
    },
    navigate(event) {
      const code = event.keyCode
      if (code === 39) {
        // right arrow
        this.nextThumb()
      }

      if (code === 37) {
        // left arrow
        this.prevThumb()
      }
    },
    nextThumb() {
      let goTo = this.activeIndex + 1
      if (goTo >= this.filesToShow.length) {
        goTo = 0
      }
      this.activateThumb(goTo)
    },
    prevThumb() {
      let goTo = this.activeIndex - 1
      if (goTo < 0) {
        goTo = this.filesToShow.length - 1
      }
      this.activateThumb(goTo)
    },
    activateThumb(thumbIndex) {
      if (!this.canClickThumbs) {
        return
      }

      this.activeIndex = thumbIndex

      const scroller = this.$refs.scroller
      if (scroller) {
        scroller.setActiveChildIndex(thumbIndex)
      }
    },
    onSwipeRight() {
      this.prevThumb()
    },
    onSwipeLeft() {
      this.nextThumb()
    },
    imgClick() {
      if (!this.$ua.isFromPc()) {
        this.toggleNavs()
      }
    },
    toggleNavs() {
      this.showNavsMobile = !this.showNavsMobile
    },
    increaseThumbsLoaded() {
      this.thumbsLoaded++
      if (this.thumbsLoaded === this.filesToShow.length) {
        // we loaded the active thumb
        this.$nextTick(() => {
          this.activateThumb(this.activeIndex)
        })
      }
    },
    async removeThumbIndex(i) {
      this.$emit('remove-file-index', i)
      await this.$nextTick()
      if (this.$refs.scroller) {
        this.$refs.scroller.calcDsWidth()
      }
    }
  }
})
